const platformTypes = [
  {
    name: 'Facebook',
    key: ['F'],
    color: '#0054ec'
  },
  {
    name: 'Whatsapp',
    key: ['W', 'WBA', 'WB', 'AW', 'WCA', 'MP'],
    color: '#268104'
  },
  {
    name: 'Telegram',
    key: ['T'],
    color: '#03a6ff'
  },
  {
    name: 'Web',
    key: ['C', 'D', 'WK'],
    color: '#ff6e00'
  },
  {
    name: 'Xenioo',
    key: ['X'],
    color: '#00ff00'
  },
  {
    name: 'Android',
    key: ['A'],
    color: '#f3021c'
  },
  {
    name: 'iOS',
    key: ['I'],
    color: '#01526b'
  },
  {
    name: 'Instagram',
    key: ['INS'],
    color: '#f455ff'
  },
  {
    name: 'Teams',
    key: ['BF'],
    color: '#9200ec'
  },
  {
    name: 'GoogleChat',
    key: ['GBM'],
    color: '#FFD500'

  }
]

export default {platformTypes}



// WEBPACK FOOTER //
// ./src/lib/PlatformTypes.js